import { render, staticRenderFns } from "./TypeSelectionCard.vue?vue&type=template&id=0819e1f8&scoped=true&"
import script from "./TypeSelectionCard.vue?vue&type=script&lang=js&"
export * from "./TypeSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./TypeSelectionCard.vue?vue&type=style&index=0&id=0819e1f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0819e1f8",
  null
  
)

export default component.exports